import Reflux from 'reflux'
import UserSetActions from '../actions/UserSetActions'

export var UserSetFormTreeChangedStore  = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(UserSetActions.userSetFormTreeChanged,'onUserSetFormTreeChanged');
	},
    onUserSetFormTreeChanged(properties)
    {
		this.trigger(properties);
    }
});

export var UserSetTreeLabelChangedStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(UserSetActions.treeLabelChanged,'onUserSetTreeLabelChanged')
	},
	onUserSetTreeLabelChanged(label)
	{
		this.trigger(label);
	}
});


// WEBPACK FOOTER //
// ./src/stores/UserSetStores.js